<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  badge?: string;
  title?: string;
  subtitle?: string;
  to?: RouteLocationRaw;
  outlined?: boolean;
  primary?: boolean;
  // disables the whole card (dimmed) + the action button
  disabled?: boolean;
  // disables only the action button
  disabledBtn?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  badge: undefined,
  title: '',
  subtitle: '',
  to: undefined,
  outlined: false,
  primary: false,
  disabled: false,
  disabledBtn: false,
});
</script>

<template>
  <div
    :class="[
      $style.jobBookingFeaturedCard,
      props.primary && $style.primary,
      props.disabled && $style.disabled,
    ]"
    data-testid="jobBookingFeaturedCard"
  >
    <div :class="$style.body">
      <span v-if="props.badge" :class="$style.badge">
        <v-icon icon="mdi-star" size="14" />
        {{ props.badge }}
      </span>
      <span :class="$style.title">{{ props.title }}</span>
      <span :class="$style.subtitle">{{ props.subtitle }}</span>
    </div>
    <KBtn
      :variant="props.outlined ? 'outlined' : 'flat'"
      :to="props.disabled || props.disabledBtn ? undefined : props.to"
      :disabled="props.disabled || props.disabledBtn"
      size="lg"
    >
      START BOOKING
    </KBtn>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/brand-primary';

.jobBookingFeaturedCard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
  border: 1px solid colors.$color-gray-200;
  border-radius: 8px;
  background-color: colors.$color-white;
  :deep(.v-btn) {
    border-radius: 24px;
  }
  &.primary {
    background-color: brand-primary.$color-brand-50;
    border-color: brand-primary.$color-brand-100;
  }
  &.disabled {
    opacity: 0.5;
  }
}
  .body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .badge {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: brand-primary.$color-brand-600;
  }
  .title {
    font-size: 1.375rem;
    font-weight: 700;
    color: colors.$color-text-primary;
    line-height: 1.2;
  }
  .subtitle {
    font-size: 0.875rem;
    color: colors.$color-text-tertiary;
    line-height: 1.5;
    max-width: 440px;
  }
</style>
